<template>
<div class=""  style="padding:0 20px;">

  <el-form ref="formBasic" :model="$contatto.profile.row" @submit.native.prevent="onSubmit" :rules="rules" label-width="180px" style="margin-top:20px;" class="label-30">

  <div class="title_h1 yo-color-primary" style="margin-bottom:30px;" v-if="$contatto.profile.rowIsNew">NEW REGISTRATION</div>

   <!-- <div class="title_h1 yo-color-primary" style="margin-top:30px;">DATI ENTE</div> -->
 
   <div class="row " style="margin-top:20px;">
 

      <div class="col s12 m6">
      <el-form-item label="Surname" prop="cognome">
        <el-input  v-model="$contatto.profile.row.cognome"></el-input>
      </el-form-item>
      </div> 
      <div class="col s12 m6">
      <el-form-item label="Name" prop="nome">
        <el-input  v-model="$contatto.profile.row.nome"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Email" prop="email">
        <el-input  v-model="$contatto.profile.row.email"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Reinsert Email" prop="emailcheck"  class="is-required">
        <el-input v-model="emailcheck"></el-input>
      </el-form-item>
      </div> 

      <div class="col s12 m6">
      <el-form-item label="Mobile phone" prop="cellulare">
        <el-input v-model="$contatto.profile.row.cellulare"></el-input>
      </el-form-item>
      </div> 
 
      <!--

      <div class="col s12 m6 clear">
      <el-form-item label="Year of birth" prop="annonascita">
        <el-date-picker v-model="$contatto.profile.row.annonascita" type="year" placeholder="Indicate your year of birth" style="width:100%;" format="yyyy" value-format="yyyy"></el-date-picker>
      </el-form-item>
      </div>

      -->

      <div class="col s12 m6">
      <el-form-item label="Nation" prop="nazione">
        <el-select v-model="$contatto.profile.row.nazione" filterable placeholder="Choose from list" style="width:100%;">
          <el-option v-for="item in $nazioni" :key="item.id" :label="item.label" :value="item.id" ></el-option>
        </el-select>
      </el-form-item>
      </div> 


      <div class="col s12" >
      <el-form-item label="Affiliation" prop="affiliazione">
        <el-input v-model="$contatto.profile.row.affiliazione"></el-input>
      </el-form-item>
      </div>

   </div>  



   <div class="title_h1 yo-color-primary" style="margin-bottom:30px;" v-if="$contatto.profile.rowIsNew">GDPR notice currently applicable from 25 May 2018</div>
   <div>
    By filling out this form, I authorize VET INTERNATIONAL srl, to handle my personal data as described in the information on the processing of personal data, in accordance with EU Regulation 2016/679 (GDPR) of 27.4.2016, visible at the following <a href="https://www.vetinternational.eu/wp-content/uploads/2020/05/VET-International-Privacy-Policy-EN-1.pdf">link</a>. 
    <br />
    For information or communications please send an e-mail to: <a href="mailto:gdpr@vetinternational.eu">gdpr@vetinternational.eu</a>

   </div>







    <div class="row pad" style="margin-top:20px;border-top:1px solid grey;padding-top:30px;padding-bottom:30px;">
      <div class="col s6 m4 offset-m2">
          <el-button style="width:100%;margin:10px 0;"  @click="onCancel">Cancel</el-button>
      </div>
        
      <div class="col s6 m4 offset-m2">
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-if="$contatto.profile.rowIsNew">Register</el-button>
          <el-button type="primary" @click="onSubmit" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;" v-else>Save</el-button>
      </div>
    </div>


    </el-form>
<!-- 
<el-button type="primary" @click="emailFirst" style="width:100%;background-color:#72BF44;border:none;margin:10px 0;">Email</el-button>
-->
</div>
</template>

<script>
import emailRegister from './Email-register.vue'
export default {
  name: 'contatto-profile',
  components: {

  },
  data() {
    return {
      //itm: this.$contatto.profile.row, //mi serve per far si che funzioni correttamente il binding
      //itmref: this.$contatto.referente.row, //mi serve per far si che funzioni correttamente il binding
      emailcheck:'',
      checkEmail: function (rule, value, callback)  {
       console.log(this.emailcheck)
       if(typeof value !='undefined')
        if (value.toString()!=this.$contatto.profile.email) {
          return callback(new Error('The control email address does not correspond to the email address!'));
        }else{
          callback();
        }
      }
    }
  },
  created () {
    console.log("Arrivo al centro-profile.vue con id "+this.$contatto.profile.row.id)
    if(typeof this.$contatto.profile.row.id == 'undefined')
      this.isNew()
    //this.$teras.pageTitle = (this.$contatto.profile.row.id=='') ? 'Nuova Attività' : 'Modifica Attività: '+this.$contatto.profile.row.id
  },
  beforeDestroy () {

  },
  methods: {
    isNew: function(){
      this.$contatto.profile.new().then((response) =>  {
        this.$contatto.profile.row.password = this.$teras.random()
      })
    },
    onCancel() {
        this.$teras.event.emit('logout')
        //this.$router.push('/login/')
    },
    onSubmit() {
      this.$refs.formBasic.validate(async (valid) => {
        if (valid) {

          let error = -1

          if(this.$contatto.profile.rowIsNew){
            if(this.$contatto.profile.row.email != this.emailcheck)
              error = 100
            
            let checkEmail = await this.$contatto.checkEmail(this.$contatto.profile.row.email,(this.$contatto.profile.row.id))
            if(checkEmail==false)
              error = 101
          }

          switch (error){
            case -1:
            this.Save()
            break;

            case 100:
            this.$alert('The control email address does not correspond to the email address!', this.$teras.alert_error)
            break;

            case 101:
            this.$alert('You already seem to be among our contacts or have already tried to register, please contact the secretariat!', this.$teras.alert_error)
            break;

            default:
            this.$alert('We\'re sorry, an error has occurred, please contact the secretariat!', this.$teras.alert_error)
          }

          
    
        } else {
          this.$alert('Not all fields have been filled in correctly!', this.$teras.alert_error)
          return false;
        }
      });
    },
    async Save(){

      this.$contatto.profile.row.cognome = this.$contatto.profile.row.cognome.toUpperCase()
      this.$contatto.profile.row.nome = this.$contatto.profile.row.nome.toUpperCase()
      this.$contatto.profile.row.modificatoil = this.$moment().format('YYYY-MM-DD HH:mm:00')
      await this.$contatto.profile.save() 

      
      if(this.$contatto.profile.rowIsNew){
        this.$contatto.saveAutore()
        this.emailFirst() 
        this.$router.push('/login/') 
        this.$alert('Congratulations, we have sent you an email with your access codes!', this.$teras.alert_success)
      }else{
        this.$router.push('/home/')      
      }
    }
    ,emailFirst(){
      var html = this.$teras.renderVue(emailRegister,{contatto:this.$contatto.profile.row,evento:this.$evento.profile.row})
      this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'New abstract management registration: '+this.$evento.profile.row.nome,to:this.$contatto.profile.row.email,body:html}).then((data) => {
        console.log("Email con registrazione del contatto inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email con la registrazione del centro")
        console.log(error)
      })
      this.$axios.email({from:this.$evento.profile.row.emailreferee,oggetto:'New abstract management registration: '+this.$evento.profile.row.nome,to:'mirko@terasmm.it',body:html}).then((data) => {
        console.log("Email con registrazione del contatto inviata")
      }).catch((error) => {
        console.log("Errore nell'invio della email con la registrazione del centro")
        console.log(error)
      })
    }

  },
  computed: {
    rules:function() {
      var rulesNow = {
        nome: [
          { required: true, message: 'Name is mandatory', trigger: 'blur' }
        ],
        cognome: [
          { required: true, message: 'Surname is mandatory', trigger: 'blur'  }
        ],
        cellulare: [
          { required: true, message: 'Mobile phone  is mandatory'}
        ],
        emailchecks: [
          { required: true, message: 'Email check is mandatory'}
        ],     
        email: [
          { required: true, message: 'Email is mandatory'},
          { type: 'email', message: 'Email is not correct', trigger: 'blur' }
        ],
        affiliazione: [
          { required: true, message: 'Affiliation is mandatory', trigger: 'blur' }
        ],
        nazione: [
          { required: true, message: 'Nation is mandatory', trigger: 'blur' }
        ]/*,
        annonascita: [
          { required: true, message: 'Year of birth is mandatory', trigger: 'blur'  }
        ]*/
        
      }
      return rulesNow
    }
  }
}
</script>
<style scoped>
</style>